// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type MoneyBackGuarantee48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const MoneyBackGuarantee48Filled: FC<MoneyBackGuarantee48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M21.65 40H7c-.8 0-1.5-.3-2.1-.9-.6-.6-.9-1.3-.9-2.1V11c0-.8.3-1.5.9-2.1C5.5 8.3 6.2 8 7 8h34c.8 0 1.5.3 2.1.9.6.6.9 1.3.9 2.1v11.95h-1.6l-12.5 12.5-6.35-6.35-6.4 6.4 4.5 4.5Zm8.25 4-8.5-8.5 2.15-2.15 6.35 6.35 12-12 2.1 2.2L29.9 44ZM7 16v6.95h34V16H7Z" />
        </svg>
    );
};

export default MoneyBackGuarantee48Filled;
